(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["SubHeader"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('smile-ui-loaded', function() {
  if (SmileUI.customer) {
    // Grab the points balance
    const points = SmileUI.customer.points_balance;
    
    // Inject it into your top bar
    document.getElementById('custom-smile-points').innerText = points;
    
    // Unhide the element now that we have the data
    document.querySelector('.header-points').style.display = 'block';
  }
});

  } catch(e) { console.error(e); }
})();
})();
